/**
 * Build version utility
 * Gets the build version injected at build time from environment variables
 */

// Get build version from Vite env variable (injected during build)
// Format: YYYYMMDD-HHMMSS-gitsha (e.g., 20251003-172530-a1b2c3d)
export const BUILD_VERSION = import.meta.env.VITE_BUILD_VERSION || 'dev-local';

// For local development, generate a dev version
export function getBuildVersion(): string {
  if (BUILD_VERSION === 'dev-local') {
    // In development, use current date + "local"
    const now = new Date();
    const dateStr = now.toISOString().slice(0, 19).replace(/[-:T]/g, '');
    return `${dateStr}-local`;
  }
  return BUILD_VERSION;
}

// Log build version on app startup (useful for debugging)
export function logBuildVersion(): void {
  const version = getBuildVersion();
  const isDev = BUILD_VERSION === 'dev-local';

  console.log(
    `%c🚀 Frontend Build Version: ${version}`,
    `color: ${isDev ? '#ff9800' : '#4caf50'}; font-weight: bold; font-size: 14px;`
  );

  if (!isDev) {
    console.log(
      `%cℹ️ Build Info:`,
      'color: #2196f3; font-weight: bold;',
      {
        timestamp: version.split('-').slice(0, 2).join('-'),
        commit: version.split('-')[2],
      }
    );
  }
}
